import {createBarbaPage} from '../baseBarbaPage';

export default createBarbaPage({
    namespace: 'checkout',
    onEnter: function() {
        // The new Container is ready and attached to the DOM.

        jQuery(document.body).on('update_checkout', () => {
            //jQuery( 'form.checkout' ).off( 'change', 'select.shipping_method, input[name^="shipping_method"], #ship-to-different-address input, .update_totals_on_change select, .update_totals_on_change input[type="radio"], .update_totals_on_change input[type="checkbox"]' );
            jQuery( 'form.checkout' ).off( 'change', '.address-field select' );
            jQuery( 'form.checkout' ).off( 'change', '.address-field input.input-text, .update_totals_on_change input.input-text' );
            jQuery( 'form.checkout' ).off( 'keydown', '.address-field input.input-text, .update_totals_on_change input.input-text');
        });
    },
    onEnterCompleted: function() {
        // The Transition has just finished.
    },
    onLeave: function() {
        // A new Transition toward a new page has just started.
    },
    onLeaveCompleted: function() {
        // The Container has just been removed from the DOM.

    }
});

// !!!! Don't forget to init the view in page-transitions/barba-init.js !!!!!
